import YardIcon from '@mui/icons-material/Yard';
import {
	Avatar,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { API } from '~/api';
import { DashboardBrandsModel } from '~/model/model.dashboard.brands';
import { UIService } from '~/service/service.ui';
import { useModel, useService } from '~/shared/service/service.base';
import { GridNoRows } from '../grid/grid.norows';
import { AsyncView } from '../view.async';

const DashboardBrandsDialog = observer<{ type: API.AnalyticsTopBrandType; open: boolean; title: string }>(
	({ type, open, title }) => {
		const [ui] = useService(UIService);
		const model = useModel(DashboardBrandsModel);

		useEffect(() => {
			if (open) model.fetchData(type);
		}, [model, open, type]);

		return (
			<Dialog open={open} fullWidth maxWidth="sm" onClose={ui.hideDialog}>
				<DialogTitle>{title}</DialogTitle>
				<DialogContent>
					<AsyncView async={model.async}>
						<List sx={{ height: '50vh' }}>
							<Virtuoso
								data={model.items}
								itemContent={(_, item) => (
									<ListItem key={item.id} dense>
										<ListItemAvatar>
											<Avatar variant="rounded" src={item.images?.at(0)}>
												<YardIcon />
											</Avatar>
										</ListItemAvatar>
										<ListItemText primary={item.name} secondary={item.count} />
									</ListItem>
								)}
								components={{
									EmptyPlaceholder: () => <GridNoRows>No brands</GridNoRows>,
								}}
							/>
						</List>
					</AsyncView>
				</DialogContent>
				<DialogActions>
					<Button onClick={ui.hideDialog}>Close</Button>
				</DialogActions>
			</Dialog>
		);
	},
);

export const DashboardBrandsViewedDialog = observer(() => {
	const [ui] = useService(UIService);
	const open = ui.dialog === DashboardBrandsViewedDialog;
	return (
		<DashboardBrandsDialog
			type={API.AnalyticsTopBrandType.viewed}
			open={open}
			title="Top brands viewed for the period"
		/>
	);
});

export const DashboardBrandsShelvesDialog = observer(() => {
	const [ui] = useService(UIService);
	const open = ui.dialog === DashboardBrandsShelvesDialog;
	return (
		<DashboardBrandsDialog
			type={API.AnalyticsTopBrandType.shelves}
			open={open}
			title="Top brands on shelves for the period"
		/>
	);
});
